<div [ngClass]="{'control-required': isRequired}"><ng-content></ng-content></div>
<div @FadeIn *ngIf="!errorMessage" class="app-control-desc mt-1" [innerHTML]="description"></div>
<div @FadeIn class="app-control-message" *ngIf="errorMessage !== null" [innerHTML]="errorMessage"></div>